// extracted by mini-css-extract-plugin
module.exports =  {"list":"da51a739f7--list--Z2H8y","list__cards":"da51a739f7--list__cards--yHkI7","list__show-wrapper":"da51a739f7--list__show-wrapper--vlwv1"};